import "./ProductsHome.css";
import React, { useEffect, useState } from "react";
import axios from "axios";

function ProductsHome() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/public/landing/products`,
          { withCredentials: true }
        );
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching home data:", error.message);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <div className="product-title">Products</div>
      <div className="product-outter-card">
        {products.map((product, index) => (
          <div
            key={product._id}
            className={index % 2 === 0 ? "product-card-one" : "product-card-two"}
          >
            <p>{product.description}</p>
            <div
              className="product-card-image-one"
              style={{
                backgroundImage: `url(${product.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductsHome;
